import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useApp } from '@/contexts/AppContext';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Breadcrumbs from './Breadcrumbs';
import ToastContainer from './ToastContainer';

export default function AppLayout({ children }: { children: ReactNode }) {
  const { sidebarOpen, setSidebarOpen } = useApp();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  if (!user) return null;

  return (
    <div className="min-h-screen bg-navy-50 font-sans">
      <Sidebar />
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <div
        className={`transition-all duration-300 ${
          sidebarOpen ? 'ml-0 lg:ml-64' : 'ml-0 lg:ml-20'
        }`}
      >
        <Topbar />
        <main className="p-3 sm:p-4 lg:p-6">
          <div className="mb-4">
            <Breadcrumbs />
          </div>
          {children}
        </main>
      </div>
      <ToastContainer />
    </div>
  );
}